import { createBrowserRouter, Link } from 'react-router'
import { RequireAdmin, Shell } from '../components/Shell'
import { AuditPage } from '../routes/AuditPage'
import { CustomerDetailPage } from '../routes/CustomerDetailPage'
import { CustomersPage } from '../routes/CustomersPage'
import { HomePage } from '../routes/HomePage'
import { LoginPage } from '../routes/LoginPage'
import { OrderDetailPage } from '../routes/OrderDetailPage'
import { OrdersPage } from '../routes/OrdersPage'
import { PaymentsPage } from '../routes/PaymentsPage'
import { StaffPage } from '../routes/StaffPage'

function NotFoundPage() {
  return (
    <div>
      <h1 className="mb-2 text-2xl font-bold">صفحه پیدا نشد</h1>
      <Link to="/" className="text-sm font-semibold text-brand-600">
        بازگشت به خانه
      </Link>
    </div>
  )
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <Shell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'customers', element: <CustomersPage /> },
      { path: 'customers/:id', element: <CustomerDetailPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'orders/:id', element: <OrderDetailPage /> },
      { path: 'payments', element: <PaymentsPage /> },
      {
        path: 'staff',
        element: (
          <RequireAdmin>
            <StaffPage />
          </RequireAdmin>
        ),
      },
      {
        path: 'audit',
        element: (
          <RequireAdmin>
            <AuditPage />
          </RequireAdmin>
        ),
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
